import React from 'react'
import PdfPage from '../components/PdfPage'
import "./index.css"
const TermsAndCondition = () => {
  return (
    <main>
      <PdfPage
        h2={"Terms & Conditions of Online Trading"}
        img={"/img/Website-Terms-and-Conditions-Guide.jpeg"}
        pdf1={"https://api.orbitsecurities.com.pk/media/cms/documents/terms-conditions-of-online-trading.pdf"}
        pdf1Text={"Download  In English"}

      />
    </main>)
}

export default TermsAndCondition